<template>
  <div>
    <el-form ref="formRef" :model="QuestionForm" label-width="88px">
      <el-form-item label="问题：">
        <el-input v-model="QuestionForm.problem" placeholder="200字以内" style="width:30em;"/>
      </el-form-item>
      <el-form-item label="回答：">
        <el-input type="textarea" placeholder="500字以内" :autosize="{ minRows: 10, maxRows: 30}" v-model="QuestionForm.reply" style="width:30em;"/>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="QuestionForm.orderNum" placeholder="请输入整数" style="width:30em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { updateOrAddProblemSet } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      QuestionForm: this.value.QuestionForm,
      idx: this.value.ids,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.QuestionForm.problem) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '问题不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.QuestionForm.reply) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '回答不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.QuestionForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.QuestionForm.id?this.QuestionForm.id:0;
      param['problem'] = this.QuestionForm.problem;
      param['reply'] = this.QuestionForm.reply;
      param['orderNum'] = this.QuestionForm.orderNum;
      postFormData(updateOrAddProblemSet, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
